import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../../components/partials/PageTitle";
import {
  attachPolicyToCustomer,
  editAttachPolicy,
  renewPolicyToCustomer,
  resetPolicyStatus,
} from "../../../redux/slice/policy/policySlice";

import PreviewPolicyAppSchedule from "../../../components/modals/preview/PreviewPolicyAppSchedule";
import { useRef } from "react";
import { useState } from "react";
import PreviewRenewalEndorsement from "./../../../components/modals/preview/PreviewRenewalEndorsement";

const PolicyRenewalPreview = () => {
  const {
    temp_policy_attach_data,
    single_policy,
    single_policy_cover,
    isUpdated,
    isLoading,
    customer_policy_details,
  } = useSelector((state) => state.policy);
  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const { all_covers } = useSelector((state) => state?.cover);

  const [policyID, setPolicyID] = useState();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const previewPaySchedule = useRef();

  const breadcrumb = {
    from: {
      title: "policy",
      link: "/admin/policy-application",
    },
    current: {
      title: "policy application preview",
      link: null,
    },
  };

  const preview = temp_policy_attach_data;

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "customer module"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);

  useEffect(() => {
    if (isUpdated) {
      if (customer_policy_details?.policy_app_details?.policyAppNumber) {
        previewPaySchedule?.current?.click();
      }
      dispatch(resetPolicyStatus());
    }
  }, [isUpdated]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Policy Application Preview' breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='row'>
                <div className='col-md-12 row'>
                  <div className='mb-3'>
                    <label htmlFor='policy' className='form-label'>
                      Policy Name
                    </label>
                    <input
                      type='text'
                      className={`form-control form-control-sm`}
                      defaultValue={
                        preview.policyName ||
                        (single_policy?.data?.p_gen_info?.id ===
                        temp_policy_attach_data?.policy_id
                          ? single_policy?.data?.p_gen_info?.name
                          : "")
                      }
                      readOnly
                    />
                  </div>
                </div>
                <div className='col-md-12 row mb-3'>
                  <div className='col-md-4'>
                    <label htmlFor='policy_name' className='form-label'>
                      Duration (in months)
                    </label>
                    <input
                      type={"number"}
                      className={`form-control form-control-sm`}
                      value={preview?.duration}
                      readOnly
                    />
                  </div>
                  <div className='col-md-4'>
                    <label htmlFor='policy_name' className='form-label'>
                      Effective Date
                    </label>
                    <input
                      type='date'
                      className={`form-control form-control-sm`}
                      value={preview?.effective_date}
                      readOnly
                    />
                  </div>
                  <div className='col-md-4'>
                    <label htmlFor='policy_name' className='form-label'>
                      End Date
                    </label>
                    <input
                      type='date'
                      className={`form-control form-control-sm`}
                      value={preview?.end_date}
                      readOnly
                    />
                  </div>
                </div>
                <div className='col-md-12 row'>
                  {/* risk covered table */}
                  <div className='col-md-12 mb-3'>
                    <table className='table table-centered table-striped nowrap w-100 no-footer'>
                      <thead>
                        <tr>
                          <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "130.8px" }}
                            aria-label='Customer: activate to sort column ascending'
                          >
                            Policy Cover Type
                          </th>
                          <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "140.8px" }}
                            aria-label='Customer: activate to sort column ascending'
                          >
                            Cover For
                          </th>
                          <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "108.8px" }}
                            aria-label='Phone: activate to sort column ascending'
                          >
                            Rate(%)
                          </th>
                          <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "147.8px" }}
                          >
                            Sum Insured
                          </th>
                          <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "147.8px" }}
                            aria-label='Email: activate to sort column ascending'
                          >
                            Annual Premium
                          </th>
                          <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "246.8px" }}
                            aria-label='Location: activate to sort column ascending'
                          >
                            Description
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {preview?.risk_covered?.map((item) => (
                          <tr key={item.id}>
                            <td>
                              {
                                all_covers?.unpaginated_cover?.filter(
                                  (p) =>
                                    String(p.id) === String(item?.cover_type)
                                )[0]?.name
                              }
                            </td>
                            <td>{item.cover_for}</td>
                            <td className='table-user'>{item.rate}</td>
                            <td className='table-user'>{item.sum_insured}</td>
                            <td className='text-dark'>{item.annual_premium}</td>
                            <td>{item.description}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* end risk covered table */}
                </div>
                <div className='col-md-12 row mb-3'>
                  <div className='col-md-4'>
                    <label htmlFor='policy_name' className='form-label'>
                      Discount (%)
                    </label>
                    <input
                      type='number'
                      className={`form-control form-control-sm`}
                      value={preview?.discount}
                      readOnly
                    />
                  </div>
                  <div className='col-md-4'>
                    <label htmlFor='policy_name' className='form-label'>
                      But Charge
                    </label>
                    <input
                      type='number'
                      className={`form-control form-control-sm`}
                      value={preview?.but_charge}
                      readOnly
                    />
                  </div>
                  <div className='col-md-4'>
                    <label htmlFor='policy_name' className='form-label'>
                      Total Annual Premium
                    </label>
                    <input
                      type='number'
                      className={`form-control form-control-sm`}
                      value={preview?.total_annual_premium?.toFixed(2)}
                      readOnly
                    />
                  </div>
                </div>
                <div className='col-md-12 mb-3 d-none'>
                  <div style={{ width: "180px" }}>
                    <span
                      className='btn btn-sm btn-primary text-white d-flex gap-2 align-items-center align-content-center justify-content-center'
                      data-bs-toggle='modal'
                      data-bs-target='#preview-schedule'
                      ref={previewPaySchedule}
                    >
                      Preview Schedule
                      <i className='mdi mdi-eye text-white fs-5'></i>
                    </span>
                  </div>
                </div>
                <div className='row'>
                  <div className='mt-4 d-flex justify-content-end'>
                    <button
                      type='button'
                      className='btn btn-info text-white me-2'
                      onClick={() => navigate(-1)}
                    >
                      <i className='mdi mdi-arrow-left me-1'></i>
                      Previous
                    </button>
                    <button
                      type='submit'
                      className='btn btn-primary text-white px-3'
                      onClick={() => {
                        dispatch(
                          renewPolicyToCustomer({
                            ...temp_policy_attach_data,
                            risks_cover: temp_policy_attach_data?.risk_covered,
                          })
                        );
                      }}
                      disabled={isLoading}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {/* preview modal */}
          {/* <PreviewPolicyAppSchedule
            modal_id='preview-schedule'
            policyID={policyID}
            data={temp_policy_attach_data}
            policyDetails={customer_policy_details?.policy_app_details}
          /> */}
          <PreviewRenewalEndorsement
            modal_id='preview-schedule'
            policyID={policyID}
            data={temp_policy_attach_data}
            policyDetails={customer_policy_details?.policy_app_details}
          />
        </div>
      </div>
    </>
  );
};

export default PolicyRenewalPreview;
